import apiClient from "../common/apiClient";

async function del() {

    let path = "";

    for ( let arg of arguments ) {

        path += "/" + arg;
        
    }

    let response = await apiClient.del(`/api${path}`);

    return response.data;

}

export default del;